import loadable from '@loadable/component';
import LoadingComponent from 'components/Loaders/LoadingComponent';

const QuickbooksLoadable = loadable(
  () => import(/* webpackChunkName: 'admin-Quickbooks' */ './Quickbooks'),
  {
    fallback: <LoadingComponent />,
  }
);

export default QuickbooksLoadable;
